import { ERA_LOOKS } from '@continuum/show-core';
import type { Chapter } from '@continuum/show-core';
import { Screen } from '../ui/Shell.js';
import { Eyebrow, Hero, Lede, PrimaryButton, mono } from '../ui/atoms.js';
import type { ScreenCopy } from '../ui/screenText.js';

const YEARS = { 1: '2026', 2: '2213', 3: '2398', 4: '2617', 5: '2791' } as const;

/**
 * A guest who boarded late (Marek, 2026-10-24: "when the guests do actually arrive and I check them in, the game
 * should … show them what they have missed"): once, after their check-in, the stops the ship has made without them —
 * each in one line of the story — and the one it is at now. Their role for this stop and, in 2213, the hidden signal's
 * call come after it, as for everyone else; their games are in the list.
 */
export function CatchUp({ chapter, callsign, s, onDone }: { chapter: Exclude<Chapter, 0>; callsign: string; s: ScreenCopy; onDone: () => void }) {
  const look = ERA_LOOKS[chapter];
  const stops = ([1, 2, 3, 4, 5] as const).filter((c) => c <= chapter);
  return (
    <Screen
      style={{ background: 'linear-gradient(180deg,#07090f,#0c1018)', color: '#e8eef6', padding: 24 }}
      footer={
        <PrimaryButton big bg={look.acc} onClick={onDone}>
          {s.catchUpGo}
        </PrimaryButton>
      }
    >
      <Eyebrow color={look.acc}>{s.catchUpKicker}</Eyebrow>
      <Hero style={{ marginTop: 12, fontSize: 30, fontWeight: 700, letterSpacing: 2, lineHeight: 1.05 }}>{s.catchUpTitle(callsign)}</Hero>
      <Lede color="#9db3c2">{s.catchUpLede}</Lede>

      <div style={{ marginTop: 18, display: 'flex', flexDirection: 'column', gap: 12 }}>
        {stops.map((c) => {
          const now = c === chapter;
          return (
            <div key={c} style={{ display: 'flex', gap: 12, alignItems: 'baseline', opacity: now ? 1 : 0.82 }}>
              <div style={{ flex: 'none', width: 44, fontFamily: mono, fontSize: 13, letterSpacing: 1, color: ERA_LOOKS[c].acc }}>{YEARS[c]}</div>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontFamily: mono, fontSize: 11, letterSpacing: 1.5, color: now ? look.acc : '#7d8e9c' }}>
                  {now ? `${s.catchUpNow} · ${s.eraTitle(c)}` : s.eraTitle(c)}
                </div>
                <div style={{ marginTop: 2, fontSize: 16, lineHeight: 1.35 }}>{s.eraStory(c)}</div>
              </div>
            </div>
          );
        })}
      </div>
    </Screen>
  );
}
